import { render, staticRenderFns } from "./Snowfall.vue?vue&type=template&id=2c619b9c&scoped=true"
import script from "./Snowfall.vue?vue&type=script&lang=js"
export * from "./Snowfall.vue?vue&type=script&lang=js"
import style0 from "./Snowfall.vue?vue&type=style&index=0&id=2c619b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c619b9c",
  null
  
)

export default component.exports